import { Transcoder } from '@img-arena/consoles-api-streaming'
import PauseIcon from '@mui/icons-material/Pause'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import { ActionMenuDialogItem } from '../ActionMenuDialogItem/ActionMenuDialogItem'
import { useActionMenuContext } from '../context/ActionMenuContext'

interface ActionToggleTranscoderStateItemProps {
  onClick: (row: Transcoder) => Promise<void> | void
}

export const ActionToggleTranscoderStateItem = ({
  onClick
}: ActionToggleTranscoderStateItemProps) => {
  const { row } = useActionMenuContext<Transcoder>()
  const isDisabled = row.disabled

  return (
    <ActionMenuDialogItem
      onClick={onClick}
      successMessage={`Transcoder ${row.id} (${row.ip}) ${isDisabled ? 'enabled' : 'disabled'} successfully`}
      errorMessage={`Failed to ${isDisabled ? 'enable' : 'disable'} Transcoder ${row.id} (${row.ip})`}
      confirmationMessage={`Are you sure you want to ${isDisabled ? 'enable' : 'disable'} Transcoder ${row.id} (${row.ip})?`}
      label={isDisabled ? 'Enable' : 'Disable'}
      overrideText={isDisabled ? 'Enable Transcoder' : 'Disable Transcoder'}
      icon={isDisabled ? <PlayArrowIcon /> : <PauseIcon />}
    />
  )
}
